import { render, staticRenderFns } from "./EditRecruitingProfileBio.vue?vue&type=template&id=e63b2558&scoped=true&"
import script from "./EditRecruitingProfileBio.vue?vue&type=script&lang=ts&"
export * from "./EditRecruitingProfileBio.vue?vue&type=script&lang=ts&"
import style0 from "./EditRecruitingProfileBio.vue?vue&type=style&index=0&id=e63b2558&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63b2558",
  null
  
)

export default component.exports